
<div class="row">
        <div class="col-md-12">
                <div class="main-title">
                  <h6>Watch Later</h6>
                </div>
              </div>
                 <div *ngFor="let content of watchlaterlist | slice:0:20 let i=index;" class="col-6 playlist col-sm-3 mb-3">
                  <div class="video-card">
                      <div class="video-card-image" [class.educationImages]="isHeadStart">
                          <a class="play-icon" routerLink="/play/{{content.currentContentView}}">
                              <i class="fas fa-play-circle"></i>
                          </a>
                          <a routerLink="/play/{{content.currentContentView}}">
                            <span *ngIf="content.contentImageUrl != null">
                              <img *ngIf="!isHeadStart" class="img-fluid" src="{{content.contentImageUrl}}" alt="">
                            </span>
                            <span *ngIf="content.contentImagePortraitUrl != null">
                              <img *ngIf="isHeadStart" class="img-fluid" src="{{content.contentImagePortraitUrl}}" alt="">
                            </span>
                            <span *ngIf="content.contentImageUrl == null">
                              <img *ngIf="!isHeadStart"  class="img-fluid" src="https://s3.us-east-2.amazonaws.com/videyo-cdn/contentImages/defaults/content-default.png" alt="">
                            </span>
                          <span *ngIf="content.contentImageUrl == null">
                            <img *ngIf="isHeadStart && video.contentImageUrl == null"  class="img-fluid" src="https://s3.us-east-2.amazonaws.com/videyo-cdn/contentImages/defaults/headstart.jpg" alt="">
                          </span>
                          <span *ngIf="content.contentImagePortraitUrl == null"><img *ngIf="isHeadStart"  class="img-fluid" src="https://s3.us-east-2.amazonaws.com/videyo-cdn/contentImages/defaults/headstart.jpg" alt="">
                          </span>
                        </a>
                        
                      </div>
                      <div class="video-card-body">
                          <div class="video-title">
                              <a routerLink="/play/{{content.currentContentView}}">{{content.title}}</a>

                          </div>
                          <div class="video-page text-success">
                              <a title="" data-placement="top" data-toggle="tooltip" routerLink="/play/{{content.currentContentView}}" data-original-title="Verified">

                              </a>
                          </div>
                      </div>
                  </div>
              </div>
</div>